/* eslint-disable max-lines-per-function */
import { DropdownMenuSeparator } from '@e2n/ui';
import {
  NavItemExternalLink,
  NavItemInternalLink,
} from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { navItemStyles } from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem/styles';
import { NewsfeedNavItem } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/NewsfeedNavItem';
import { SubMenuType } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/types';
import { createSettingsLink } from '@/domain/navigation/features/navigation/utils/helpers';
import { useProfile } from '@/hooks';
import { cn } from '@/lib/utils';
import { buildLink, managerV1BaseUrl } from '@/utils';
import { faArrowRightFromBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function useProfileSubmenuItems({
  handleClose,
  setActiveSubmenu,
}: {
  handleClose: () => void;
  setActiveSubmenu: (type: SubMenuType) => void;
}) {
  const { t } = useTranslation();
  const profile = useProfile();
  const manager = profile.manager;
  const menuItems = [];

  if (manager.rechte.admin) {
    menuItems.push(
      <NavItemExternalLink href={buildLink('allgemein')}>
        {t('general.navigation.profileDropdown.administration')}
      </NavItemExternalLink>,
    );
  }

  if (manager.hasEinstellungenRecht()) {
    const link = createSettingsLink(manager);
    menuItems.push(
      <NavItemExternalLink href={link}>
        {t('general.navigation.profileDropdown.settings')}
      </NavItemExternalLink>,
    );
  }

  if (manager.rechte.admin) {
    menuItems.push(
      <NavItemInternalLink to="/vertraege" onClick={() => handleClose()}>
        {t('general.navigation.profileDropdown.contracts')}
      </NavItemInternalLink>,
    );
  }

  menuItems.push(
    <NavItemInternalLink to="/profile" onClick={() => handleClose()}>
      {t('general.navigation.profileDropdown.myProfile')}
    </NavItemInternalLink>,
  );

  if (manager.rechte.admin || manager.hasEinstellungenRecht()) {
    menuItems.push(<DropdownMenuSeparator className="mx-2" />);
  }

  menuItems.push(<NewsfeedNavItem setActiveSubmenu={setActiveSubmenu} />);

  menuItems.push(
    <NavItemExternalLink href={buildLink('datenschutz')}>
      {t('general.navigation.profileDropdown.privacy')}
    </NavItemExternalLink>,
  );

  menuItems.push(
    <NavItemExternalLink
      href="https://hilfe.e2n.de"
      target="_blank"
      rel="noreferrer">
      {t('general.navigation.profileDropdown.help')}
    </NavItemExternalLink>,
  );

  menuItems.push(
    <NavItemExternalLink
      href="https://get.teamviewer.com/e2ngastro"
      target="_blank"
      rel="noreferrer">
      {t('general.navigation.profileDropdown.remoteMaintenance')}
    </NavItemExternalLink>,
  );

  menuItems.push(<DropdownMenuSeparator className="mx-2" />);

  menuItems.push(
    <button
      className={cn(
        navItemStyles(),
        'flex items-center justify-between w-full text-primary-red-400',
      )}
      onClick={() => {
        window.location.href = `${managerV1BaseUrl}/logout`;
      }}>
      <div className="flex items-center gap-2">
        <FontAwesomeIcon icon={faArrowRightFromBracket} />
        {t('general.navigation.profileDropdown.logout')}
      </div>
    </button>,
  );

  return menuItems;
}
